module.exports = __webpack_public_path__ + "static/img/logo.567ab436.png";